import RestService from "./RestService";

export default class MyFormsService extends RestService {
  constructor() {
    super("/api/myforms");
  }

  async searchForm(params) {
    return this.get(`${this.baseUrl}/search`, params);
  }
}
